﻿<global-search></global-search>
<nav-bar #navBar></nav-bar>
<div class="main-section" [ngClass]="{expanded: navBar.isCollapsed, 'dark-theme': isDarkMode}">
  <div class="feature-content">
    <router-outlet></router-outlet>
  </div>
  <banner></banner>
  <permanent-banner></permanent-banner>
  <toast></toast>
</div>